<template>
  <!--两客一危一重客户参数-->
  <div>
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="两客一危一重客户参数名称" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addGdDlysjgClientParamModal=true">添加两客一危一重客户参数</Button>
      <label>[注意：账号类型为'客户账号'时,'客户名称'字段必须和省平台客户单位名称对应,否则会导出单个客户台账失败]</label>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <Row>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="refreshAll">刷新</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <Col span="12">
        <div style="width: 100%;">
          <Table border highlight-row size="small" height="600" :columns="eventColumns" :stripe="true" :data="eventContent" ref="eventTable" :height="eventTableHeight"></Table>
        </div>
      </Col>
      <Col span="12">
        <div style="width: 100%;">
          <Table border highlight-row size="small" height="600" :columns="inquireColumns" :stripe="true" :data="inquireContent" :height="eventTableHeight"></Table>
        </div>
      </Col>
    </Row>

    <audio controls="controls" hidden src="/alarm.aac" ref="alarmAudio"></audio>
    <audio controls="controls" hidden src="/valarm.wav" ref="vAlarmAudio"></audio>
    <add-gd-dlysjg-client-param-modal v-model="addGdDlysjgClientParamModal" @on-success="onSuccess"></add-gd-dlysjg-client-param-modal>
    <gd-dlysjg-client-param-detail-modal v-model="gdDlysjgClientParamModal" :initValue="gdDlysjgClientParamId" @on-success="onModifySuccess"></gd-dlysjg-client-param-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>

  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

import AddGdDlysjgClientParamModal from '@/view/gd-dlysjg/components/add-gd-dlysjg-client-param-modal'
import GdDlysjgClientParamDetailModal from '@/view/gd-dlysjg/components/gd-dlysjg-client-param-detail-modal'

export default {
  name: 'gddlysjghazardevents',
  components: {
    AddGdDlysjgClientParamModal,
    GdDlysjgClientParamDetailModal
  },
  data () {
    return {

      authorizationStateFilter: null,
      accountTypeFilter: null,

      refreshTimer: null,

      eventContent: [],
      inquireContent: [],

      // 增加两客一危一重客户参数
      addGdDlysjgClientParamModal: false,

      // 两客一危一重客户参数详细
      gdDlysjgClientParamModal: false,
      gdDlysjgClientParamId: null,

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],
      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      eventTableHeight: 300,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      inquireColumns: [
        {
          title: '查岗类型',
          resizable: true,
          key: 'stationType',
          tooltip: 'true',
          width: 130
        },
        {
          title: '被查单位',
          resizable: true,
          key: 'ownerName',
          tooltip: 'true',
          width: 220
        },
        {
          title: '查岗问题',
          resizable: true,
          key: 'inquireQuestion',
          tooltip: 'true'
        },
        {
          title: '查岗时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'inquireTime',
          width: 160,
          render: function (h, params) {
            if (params.row.inquireTime) {
              let d = new Date(params.row.inquireTime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        }
      ],

      eventColumns: [
        {
          title: '报警名称',
          resizable: true,
          key: 'alarmCodeName',
          sortable: 'custom',
          tooltip: 'true',
          width: 130
        },
        {
          title: '报警级别',
          resizable: true,
          key: 'alarmLevel',
          ellipsis: 'true',
          width: 130
        },
        {
          title: '报警时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'alarmTime',
          width: 160,
          render: function (h, params) {
            if (params.row.alarmTime) {
              let d = new Date(params.row.alarmTime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '车牌号',
          resizable: true,
          key: 'vehicleNo',
          ellipsis: 'true',
          minWidth: 120
        },
        {
          title: '车辆所有人名称',
          resizable: true,
          key: 'ownerName',
          ellipsis: 'true'
        }
      ],

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 130
        },
        {
          title: '客户名称',
          resizable: true,
          key: 'clientName',
          ellipsis: 'true',
          width: 300
        },
        {
          title: '账号类型',
          resizable: true,
          key: 'accountType',
          ellipsis: 'true',
          width: 120,
          filterMultiple: true,
          filters: [
            { label: '客户账号', value: 1 },
            { label: '三方监控中心', value: 2 }
          ],
          filterRemote: (val) => {
            if (val.length > 0) {
              this.accountTypeFilter = []
              val.forEach(item => {
                this.accountTypeFilter.push(genQueryParam('accountType', 'EQ', item))
              })
            } else {
              this.accountTypeFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.accountType == 1) {
              return h('div', '客户账号')
            } else if (params.row.accountType == 2) {
              return h('div', '三方监控中心')
            }
          }
        },
        {
          title: '授权码',
          resizable: true,
          key: 'authorizationCode',
          ellipsis: 'true',
          width: 400
        },
        {
          title: '授权码状态',
          resizable: true,
          key: 'authorizationState',
          ellipsis: 'true',
          width: 120,
          filterMultiple: true,
          filters: [
            { label: '授权码过期', value: 0 },
            { label: '测试中', value: 1 },
            { label: '已登录', value: 2 }
          ],
          filterRemote: (val) => {
            if (val.length > 0) {
              this.authorizationStateFilter = []
              val.forEach(item => {
                this.authorizationStateFilter.push(genQueryParam('authorizationState', 'EQ', item))
              })
            } else {
              this.authorizationStateFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.authorizationState == 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '授权码过期')
              ])
            } else if (params.row.authorizationState == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '测试中')
              ])
            } else if (params.row.authorizationState == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'green'
                  }
                }, '已登录')
              ])
            }
          }
        },
        {
          title: '最后登录时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'lastLoginedDatetime',
          width: 220,
          render: function (h, params) {
            if (params.row.lastLoginedDatetime) {
              let d = new Date(params.row.lastLoginedDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 220,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    console.log('AA')
                    this.gdDlysjgClientParamId = params.row.id
                    this.gdDlysjgClientParamModal = true
                  }
                }
              }, '详细信息')
            ])
          }
        }
      ]// cloumn

    }
  },
  methods: {
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    refreshAll () {
      this.refreshInquirePage()
      this.refreshEventPage()
    },
    refreshEventPage () {
      store.dispatch('GdDlysjgHazardEventServ_GetRealtimeHazardEventList', {
        params: null,
        urlparams: null
      }).then(() => {
        let hasAlarm = false
        this.eventContent = store.getters.get_GdDlysjgHazardEvent_GetRealtimeHazardEventListResult
        if (this.eventContent && this.eventContent.length > 0) {
          let d = new Date()
          let timeNow = d.getTime()
          let isVAlarm = false
          console.log('timeNow:' + timeNow)
          for (let i = 0; i < this.eventContent.length; i++) {
            console.log('createTime:' + this.eventContent[i].alarmTime)
            console.log('span:' + (timeNow - this.eventContent[i].alarmTime))
            if ((timeNow - this.eventContent[i].alarmTime) > 10800000) {
              console.log('ignore alarm')
              continue
            }
            hasAlarm = true
            if (this.eventContent[i].alarmLevel == '1') {
              // 一级报警40分钟后变声
              if ((timeNow - this.eventContent[i].alarmTime) > 2400000) {
                isVAlarm = true
                break
              }
            } else if (this.eventContent[i].alarmLevel == '2') {
              // 二级报警1小时40分钟后变声
              if ((timeNow - this.eventContent[i].alarmTime) > 6000000) {
                isVAlarm = true
                break
              }
            } else if (this.eventContent[i].alarmLevel == '3') {
              // 三级报警2小时40分钟后变声
              if ((timeNow - this.eventContent[i].alarmTime) > 9600000) {
                isVAlarm = true
                break
              }
            } else {
              // 其他报警30分钟后变声
              if ((timeNow - this.eventContent[i].alarmTime) > 1800000) {
                isVAlarm = true
                break
              }
            }
          }

          if (hasAlarm) {
            if (isVAlarm) {
              this.$refs.vAlarmAudio.currentTime = 0 // 从头开始播放提示音
              this.$refs.vAlarmAudio.play() // 播放
            } else {
              this.$refs.alarmAudio.currentTime = 0 // 从头开始播放提示音
              this.$refs.alarmAudio.play() // 播放
            }
          }
        }
      }).catch(err => {
        this.eventContent = []
        this.$Message.error(err)
      })
    },
    refreshInquirePage () {
      store.dispatch('GdDlysjgHazardEventServ_GetRealtimeInquireList', {
        params: null,
        urlparams: null
      }).then(() => {
        this.inquireContent = store.getters.get_GdDlysjgHazardEvent_GetRealtimeInquireListResult
        if (this.inquireContent && this.inquireContent.length > 0) {
          this.$refs.alarmAudio.currentTime = 0 // 从头开始播放提示音
          this.$refs.alarmAudio.play() // 播放
        }
      }).catch(err => {
        this.inquireContent = []
        this.$Message.error(err)
      })
    },
    filterChange () {
      this.setPage(1)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.authorizationStateFilter) {
        qo1 = this.authorizationStateFilter
      }
      if (this.accountTypeFilter) {
        qo2 = this.accountTypeFilter
      }

      store.dispatch('GdDlysjgClientParamServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    timerCallback () {
      this.refreshPage()
      this.refreshAll()
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_GdDlysjgClientParam_GetPageResult) {
        return store.getters.get_GdDlysjgClientParam_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_GdDlysjgClientParam_GetPageResult) {
        return store.getters.get_GdDlysjgClientParam_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_GdDlysjgClientParam_GetPageResult) {
        return store.getters.get_GdDlysjgClientParam_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = 300
      this.eventTableHeight = window.innerHeight - this.$refs.eventTable.$el.offsetTop - 140 - this.tableHeight
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140 - this.tableHeight
      }
      this.setPage(1)
      // 测试声音
      // this.$refs.alarmAudio.currentTime = 0; //从头开始播放提示音
      // this.$refs.alarmAudio.play(); //播放
      this.refreshTimer = setInterval(this.timerCallback, 15000)
    })
  },
  destroyed () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }
}
</script>

<style scoped>

</style>
